import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { VisualizzaPRFilterComponent } from './visualizza-pr-filter';

export const VisualizzaPRFilterModule: string = ng
    .module('visualizza-pr-filter', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('visualizzaPRFilterComponent', VisualizzaPRFilterComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/visualizza-pr-filter/visualizza-pr-filter.module.ts